import React from 'react';
import './index.sass';

// Технологичная подложка как в презентациях wsgfactory:
// граф-сеть из узлов со связями, радар (концентрические окружности),
// потоки данных, инженерная сетка. Полупрозрачно, под текстом.
const TechBackground = () => {
    return (
        <div className="TechBG" aria-hidden="true">
            <svg className="TechBG__Svg" viewBox="0 0 1440 1024" preserveAspectRatio="xMidYMid slice" fill="none">
                {/* === ГРАФ-СЕТЬ: узлы + связи (как нейросеть/экосистема) === */}
                <g className="TechBG__Graph">
                    {/* связи */}
                    <g stroke="rgba(99,91,255,0.18)" strokeWidth="1">
                        <line x1="180" y1="180" x2="360" y2="120" />
                        <line x1="360" y1="120" x2="520" y2="240" />
                        <line x1="520" y1="240" x2="640" y2="150" />
                        <line x1="180" y1="180" x2="300" y2="320" />
                        <line x1="300" y1="320" x2="520" y2="240" />
                        <line x1="300" y1="320" x2="460" y2="420" />
                        <line x1="460" y1="420" x2="640" y2="150" />
                        <line x1="640" y1="150" x2="780" y2="280" />
                    </g>
                    {/* узлы */}
                    <g fill="#635bff">
                        <circle cx="180" cy="180" r="4" opacity="0.7" />
                        <circle cx="360" cy="120" r="5" opacity="0.85" />
                        <circle cx="520" cy="240" r="4" opacity="0.7" />
                        <circle cx="640" cy="150" r="6" opacity="0.9" />
                        <circle cx="300" cy="320" r="4" opacity="0.65" />
                        <circle cx="460" cy="420" r="3.5" opacity="0.6" />
                        <circle cx="780" cy="280" r="4" opacity="0.7" />
                    </g>
                    {/* кольца вокруг ключевого узла */}
                    <g stroke="rgba(99,91,255,0.22)" strokeWidth="1" fill="none">
                        <circle cx="640" cy="150" r="20" />
                        <circle cx="640" cy="150" r="34" strokeDasharray="2 6" />
                    </g>
                </g>

                {/* === РАДАР: концентрические окружности с делениями === */}
                <g className="TechBG__Radar" transform="translate(1240 760)">
                    <g stroke="rgba(11,179,154,0.20)" strokeWidth="1" fill="none">
                        <circle r="46" />
                        <circle r="92" strokeDasharray="2 7" />
                        <circle r="140" opacity="0.6" />
                        <circle r="188" opacity="0.35" />
                    </g>
                    {/* перекрестье радара */}
                    <g stroke="rgba(11,179,154,0.16)" strokeWidth="1">
                        <line x1="-188" y1="0" x2="188" y2="0" />
                        <line x1="0" y1="-188" x2="0" y2="188" />
                    </g>
                    {/* луч-разворотка */}
                    <line x1="0" y1="0" x2="133" y2="-133" stroke="rgba(11,179,154,0.30)" strokeWidth="1.2" />
                    <circle r="4" fill="#0bb39a" opacity="0.85" />
                    {/* метки на окружности */}
                    <g fill="rgba(11,179,154,0.6)">
                        <circle cx="92" cy="0" r="2.2" />
                        <circle cx="0" cy="-92" r="2.2" />
                        <circle cx="65" cy="65" r="2" opacity="0.7" />
                    </g>
                </g>

                {/* === ПОТОКИ ДАННЫХ: волнистые линии-трассы === */}
                <g className="TechBG__Flow" stroke="url(#flowGrad)" strokeWidth="1.2" fill="none" opacity="0.5">
                    <path d="M -50 560 Q 200 480, 380 560 T 760 560 T 1140 560 T 1500 560" />
                    <path d="M -50 640 Q 220 720, 420 640 T 820 640 T 1500 640" opacity="0.6" />
                </g>

                {/* === ОРБИТЫ справа сверху === */}
                <g className="TechBG__Orbits">
                    <g stroke="rgba(122,92,255,0.20)" strokeWidth="1" fill="none">
                        <circle cx="1280" cy="150" r="60" />
                        <circle cx="1280" cy="150" r="110" strokeDasharray="2 8" />
                        <circle cx="1280" cy="150" r="165" opacity="0.5" />
                    </g>
                    {/* спутник-точка на орбите */}
                    <circle cx="1340" cy="150" r="3.5" fill="#7a5cff" opacity="0.8" />
                    <circle cx="1280" cy="150" r="3" fill="rgba(122,92,255,0.7)" />
                </g>

                {/* === ДИАГОНАЛЬНЫЕ ЛУЧИ === */}
                <g stroke="url(#lineGrad)" strokeWidth="1" opacity="0.55">
                    <line x1="-100" y1="900" x2="700" y2="-50" />
                    <line x1="900" y1="1080" x2="1540" y2="430" opacity="0.7" />
                </g>

                {/* === СЕТКА УЗЛОВ (точки) по нижней части === */}
                <g className="TechBG__Dots" fill="rgba(99,91,255,0.4)">
                    <circle cx="200" cy="820" r="2" />
                    <circle cx="280" cy="820" r="2" />
                    <circle cx="360" cy="820" r="2" />
                    <circle cx="200" cy="900" r="2" opacity="0.6" />
                    <circle cx="280" cy="900" r="2" opacity="0.6" />
                    <circle cx="980" cy="200" r="2" opacity="0.5" />
                    <circle cx="1060" cy="200" r="2" opacity="0.5" />
                    <circle cx="1140" cy="200" r="2" opacity="0.5" />
                </g>

                <defs>
                    <linearGradient id="flowGrad" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stopColor="#635bff" stopOpacity="0" />
                        <stop offset="40%" stopColor="#635bff" stopOpacity="0.5" />
                        <stop offset="70%" stopColor="#0bb39a" stopOpacity="0.45" />
                        <stop offset="100%" stopColor="#0bb39a" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#635bff" stopOpacity="0" />
                        <stop offset="50%" stopColor="#635bff" stopOpacity="0.4" />
                        <stop offset="100%" stopColor="#7a5cff" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    );
};

export default TechBackground;
